import { useTranslation } from "react-i18next";
import { generatePath, useHistory } from "react-router-dom";
import routing from "routing";
import LessonActions from "src/components/NewComponents/menuActions/LessonActions";
import ExamActions from "src/components/NewComponents/Views/Actions/ExamActions";
import { ExamStatisticsIconButton } from "src/components/NewComponents/Views/ScoreViews/ExamView";
import EditIcon from "src/images/Icons/newIcons/exam/more/edit.svg";

interface InProgressActionsProps {
	lesson: any;
	toggleNote: () => void;
}

export const InProgressActions = ({ lesson, toggleNote }: InProgressActionsProps) => {
	const { t } = useTranslation();
	const history = useHistory();
	const goToUnfinished = () => {
		return history.push(
			generatePath(routing.paths.exam, { id: lesson.exam.id }),
		);
	};

	const onPrimary = () => {
		if (lesson.exam.status === "active") {
			return goToUnfinished();
		}

		return history.push(
			generatePath(routing.paths.exam, {
				id: lesson.exam.id,
				questionId: 1,
			}),
		);
	};

	return (
		<ExamActions
			row={lesson.exam}
			onPrimary={onPrimary}
			menuActions={
				<LessonActions
					row={lesson.exam}
					additionalActions={[
						{
							title: t("menuActions.lessons.addNote"),
							onClick: toggleNote,
							Icon: <EditIcon className="icon-small" />,
						},
					]}
				/>
			}
			renderStats={<ExamStatisticsIconButton exam={lesson.exam} />}
		/>
	);
};
